import classnames from 'classnames';
import plus from 'src/global/assets/icons/plus.svg';
import Text from 'src/components/Text';
import GenericActionButton from 'src/components/GenericActionButton';
import ContentLayout from 'src/layouts/ContentLayout';
import Icon from 'src/components/Icon';

import { styles } from './styles';

export interface EmptyListType {
  className?: string;
  image?: string;
  message?: string;
  buttonLabel?: string;
  buttonOnClick?: () => void;
  hasButton?: boolean;
}

function EmptyList({
  className,
  image,
  message,
  buttonLabel,
  hasButton = true,
  buttonOnClick
}: Readonly<EmptyListType>) {
  const { classes } = styles();
  return (
      <ContentLayout hasBackground fullContainer>
      <div className={classnames(classes.container, className)}>
        {image ? <img src={image} alt="Comercios" width="200" /> : null}
        {message ? (
          <Text className={classes.message} variant="H2-Regular">
            {message}
          </Text>
        ) : null}
        {hasButton ? (
          <GenericActionButton
            startIcon={<Icon source={plus} alt={'Icono Mas'} />}
            label={buttonLabel}
            onClick={buttonOnClick}
          />
        ) : null}
      </div>
    </ContentLayout>
  );
}

export default EmptyList;
